import React, { FC, useState } from 'react';

import { ActionTile } from '../../../shared/ui';

import { UploadAudioIcon } from '../../icons/upload-audio-icon';

import { UploadAudioModal } from './upload-audio-modal';

const TOOLTIP_TEXT =
  'Для аудиозаписей очных сессий. Если сессия прошла в ZiNGiZi — транскрибация и анализ встроены в видеозвонок.';
const TOOLTIP_ID = 'upload-audio-tooltip';

type UploadAudioWidgetProps = {
  /** Список имён клиентов для выбора в попапе (опционально). */
  clientNames?: string[];
};

export const UploadAudioWidget: FC<UploadAudioWidgetProps> = ({ clientNames = [] }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="relative w-full self-center flex justify-center">
      <ActionTile
        variant="outline"
        icon={<UploadAudioIcon />}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        onClick={() => setModalOpen(true)}
        aria-describedby={showTooltip ? TOOLTIP_ID : undefined}
      >
        Загрузить аудиозапись
      </ActionTile>
      {showTooltip && (
        <div
          id={TOOLTIP_ID}
          role="tooltip"
          className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-20 w-[249px] px-2 py-1.5 rounded-chip bg-surface-inverse text-white text-ui-s font-normal leading-[1.23] shadow-popup pointer-events-none"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-ink" />
          {TOOLTIP_TEXT}
        </div>
      )}
      <UploadAudioModal isOpen={modalOpen} onClose={() => setModalOpen(false)} clientNames={clientNames} />
    </div>
  );
};

export default UploadAudioWidget;
